import { AMFurnitureFinishesReference } from '../components/AMFurnitureFinishesReference';
import { SceneConstants } from '../../SavaneJS';

/**
 * This class will get asset manager reference to filler/plinth/endPanel
 */
export class AMComponentFactory {

    private static _loadedAssets: { fillers: any[]; endPanels: any[]; plinths: any[] } = {
        fillers: [],
        endPanels: [],
        plinths: []
    };

    constructor() {
    }

    /**
     * return asset loaded locally
     *
     * @returns {{fillers: Array, endPanels: Array, plinths: Array}|*}
     */
    static get loadedAssets() {
        return AMComponentFactory._loadedAssets;
    }

    /**
     * return the associated plinth of the arrangement (from local array)
     *
     * @param arrangement
     * @returns {*}
     */
    static findLocalPlinth(arrangement: any) {
        if (AMComponentFactory.loadedAssets.plinths.length >= 1) {
            return AMComponentFactory.loadedAssets.plinths[0];
        }
        return null;
    }

    /**
     * return the associated endPanel of the arrangement (from local array)
     *
     * @param arrangement
     * @returns {*}
     */
    static findLocalEndPanels(arrangement: any) {
        let i, j, endPanel, chosenEndPanels: any[] = [],
            size = arrangement.getChildren([SceneConstants.EntityType.SketchBlock]).length === 1 ?
                arrangement.getChildren([SceneConstants.EntityType.SketchBlock])[0] : arrangement;
        for (i = 0; i < AMComponentFactory.loadedAssets.endPanels.length; i++) {
            endPanel = AMComponentFactory.loadedAssets.endPanels[i];
            for (j = 0; j < endPanel.configs.length; j++) {
                if (endPanel.configs[j].coating !== null && endPanel.configs[j].coating !== undefined &&
                    endPanel.configs[j].coating.item !== null && endPanel.configs[j].coating.item !== undefined &&
                    endPanel.configs[j].coating.item._id === arrangement.coatingId &&
                    endPanel.sketchBlock !== undefined && endPanel.sketchBlock !== null &&
                    endPanel.sketchBlock.dimensions !== undefined && endPanel.sketchBlock.dimensions !== null &&
                    endPanel.sketchBlock.dimensions.length <= size.width && endPanel.sketchBlock.dimensions.height <= size.height) {
                    if (chosenEndPanels.length === 0 || (
                        endPanel.sketchBlock.dimensions.height > chosenEndPanels[0].sketchBlock.dimensions.height &&
                        endPanel.sketchBlock.dimensions.length > chosenEndPanels[0].sketchBlock.dimensions.length
                    )) {
                        chosenEndPanels = [endPanel];
                    } else if (endPanel.sketchBlock.dimensions.height === chosenEndPanels[0].sketchBlock.dimensions.height &&
                        endPanel.sketchBlock.dimensions.length === chosenEndPanels[0].sketchBlock.dimensions.length) {
                        chosenEndPanels.push(endPanel);
                    }
                }
            }
        }
        return chosenEndPanels;
    }

    /**
     * return the associated filler of the arrangement (from local array)
     *
     * @param arrangement
     * @returns {*}
     */
    static findLocalFiller(arrangement: any) {
        let i, j, filler;
        for (i = 0; i < AMComponentFactory.loadedAssets.fillers.length; i++) {
            filler = AMComponentFactory.loadedAssets.fillers[i];
            for (j = 0; j < filler.configs.length; j++) {
                if (filler.configs[j].coating !== null && filler.configs[j].coating !== undefined &&
                    filler.configs[j].coating.item !== null && filler.configs[j].coating.item !== undefined &&
                    filler.configs[j].coating.item._id === arrangement.coatingId) {
                    return filler;
                }
            }
        }
        return null;
    }

    /**
     * create component reference from assets data
     *
     * @param plinth
     * @param endPanel
     * @param filler
     * @param coatingId
     * @returns {AMFurnitureFinishesReference}
     */
    static createComponentFromAssets(plinth: any, endPanels: any, filler: any, coatingId: any) {
        let am = new AMFurnitureFinishesReference();
        am.updateFromAssets(plinth, endPanels, filler, coatingId);
        return am;
    }

    /**
     * Return new component given the arrangement
     * @param arrangement
     */
    static createComponent(arrangement: any) {
        //try to find object in already loaded object
        let filler = AMComponentFactory.findLocalFiller(arrangement);
        let endPanels = AMComponentFactory.findLocalEndPanels(arrangement);
        let plinth = AMComponentFactory.findLocalPlinth(arrangement);

        //create AMFurnitureFinishesReference with local data, if some data are missing, an request will be made and the data will be updated after receiving
        let am = AMComponentFactory.createComponentFromAssets(plinth, endPanels, filler, arrangement.coatingId);

        return am;
    }
}
